import { render } from "./Projecten.vue?vue&type=template&id=7d2d32d8"
import script from "./Projecten.vue?vue&type=script&lang=js"
export * from "./Projecten.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__